import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import media from '../../../../theme/media';

const AnimationName = keyframes `
  0%{background-position: 50% 0%;}
  50%{background-position: 0% 50%;}
  100%{background-position: 50% 0%;}
`;

const EditorContainer = styled.div`
  max-width: 720px;
  margin: 0 auto;
  ${media.phone`
      max-width: calc(100vw - 48px);
  `}

  .mzp-button {
      border: 0;
      cursor: pointer;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      text-decoration: none;
      padding: 8px 16px;
      border-radius: 2px;
      box-sizing: border-box;
      outline: none;
      position: relative;
      background: transparent;
      border: 2px solid #000000;
      top: 0;
      left: 0;

      &:hover {
          color: #000000;
          background: #FFFFFF;
          box-shadow: 4px 4px 0 0 #000000;
          transition: box-shadow .2s;
      }
      &:focus {
          box-shadow: 0 0 0 4px rgba(0, 96, 223, .2);
          border: 2px solid #0060df;
      }
      &:active {
          box-shadow: 2px 2px 0 0 #000000;
          transition: box-shadow 0s;
      }

      &.mzp-button-small {
          padding: 4px 16px;
      }
      &.mzp-button-medium {
          padding: 8px 16px;
      }
      &.mzp-button-large {
          padding: 12px 24px;
          border-radius: 4px;
      }

      &.mzp-button-primary {
          background: #000000;
          color: #FFFFFF;
          border: 2px solid #000000;
          &:hover {
              background: transparent;
              color: #000000;
          }
      }
      &.mzp-button-secondary {
          background: transparent;
          border: 2px solid #000000;
      }

      .mzp-button-shift:hover {
          box-shadow: 4px 4px 0 0 #FE448D, -4px -4px 0 0 #61CCDD;
          transition:box-shadow .2s;
      }

      .mzp-button-shift:active {
          box-shadow: 2px 2px 0 0 #FE448D, -2px -2px 0 0 #61CCDD;
          transition:box-shadow 0s;
      }

      &.mzp-button-light {
        background: transparent;
        border: 2px solid #FFFFFF;
        color: #FFFFFF;
        &:hover {
          background: rgba(255, 255, 255, .2);
          box-shadow: 4px 4px 0 0 rgba(255, 255, 255, .2);
        }
      }

  }




  .mzp-button-download {
      background: #0060df;
      color: #FFFFFF;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
      border: none;
      z-index: 1;
      padding: 10px 18px;

      // Layers
      &:before,
      &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 2px;
      }
      &:before {
          z-index: -1;
          background: #0060df;
      }
      &:after {
          z-index: -2;
          transition: top .1s ease, right .1s ease, bottom .1s ease, left .1s ease;
      }

      // States
      &:hover {
          background: #003EAA;
          color: #FFFFFF;
          box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
          &:before {
            background: #003EAA;
          }
      }
      &:focus {
          border: none;
      }
      &.mzp-button-firefox,
      &.mzp-button-beta,
      &.mzp-button-nightly,
      &.mzp-button-devedition,
      &.mzp-button-focus {
          &:hover {
              &:after{
                  top: 6px;
                  left: 6px;
                  right: -4px;
                  bottom: -4px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
              }
          }
          &:active {
              &:after {
                  top: 4px;
                  left: 4px;
                  right: -2px;
                  bottom: -2px;
              }
          }
          &:focus {
              border: none;
          }
      }

      &.mzp-button-small {
          padding: 6px 18px;
      }
      &.mzp-button-medium {
          padding: 10px 18px;
      }
      &.mzp-button-large {
          padding: 14px 26px;
          border-radius: 4px;
      }

      &.mzp-button-firefox {
          &:hover {
              &:after {
                  background: linear-gradient(to top right, #CA0B69, #FF780A, #FFEF31);
                  background-size: 400% 400%;
                  animation: ${AnimationName} 2s ease infinite;
              }
          }
      }
      &.mzp-button-beta {
          &:hover {
              &:after {
                  background: linear-gradient(45deg, #00F9F0, #13EF44);
                  background-size: 400% 400%;
                  animation: ${AnimationName} 2s ease infinite;
              }
          }
      }
      &.mzp-button-nightly {
          &:hover {
              &:after {
                  background: linear-gradient(45deg, #C45AF2, #00E7FF, #00D6C3);
                  background-size: 400% 400%;
                  animation: ${AnimationName} 2s ease infinite;
              }
          }
      }
      &.mzp-button-devedition {
          &:hover {
              &:after {
                  background: linear-gradient(45deg, #007CE6, #00EEFF);
                  background-size: 400% 400%;
                  animation: ${AnimationName} 2s ease infinite;
              }
          }
      }
      &.mzp-button-focus {
          &:hover {
              &:after {
                  background: linear-gradient(45deg, #9A2192, #DA1793);
                  background-size: 400% 400%;
                  animation: AnimationName 2s ease infinite;
              }
          }
      }
  }
  
  .protosite-pattern-editor {
    @include grid(5/8);
    margin-left: 1/8 * 100%;
    padding: 0;
}
.protosite-pattern-table {
  border-collapse: collapse;
  margin-bottom: 2rem;
  width: 100%;
  font-size: 1rem;
  ${media.phone`
    td:nth-child(2) {
      display: none;
    }
    th:nth-child(2) {
      display: none;
    }
  `}
  tr {
    &:last-child {
      border-bottom: none;
    }
  }
  th, td {
    text-align: left;
    padding: 12px 16px;
    &:first-child {
      width: 20%;
      padding: 12px 16px 12px 0;
    }
    &:nth-child(2) {
      width: 40%;
    }
    &:nth-child(3) {
      width: 40%;
      padding: 12px 0 12px 16px;
    }
    input, select, textarea {
      width: 100%;
      height: 32px;
      font-size: 1rem;
      background: white;
      border: 1px solid #BFBFBF;
      &:hover {
        border: 1px solid #0060DF;
      }
      &:focus {
        background: #F1F6FD;
        border: 1px solid #0060DF;
      }
    }
    select {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .25);
    }
    input[type=text] {
      padding: 0 .5rem;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, .25);
    }
  }
  .protosite-toggle {
      display: flex;
      position: relative;
      .protosite-toggle-option {
          flex: 1 50%;
          position: relative;
      }
      input {
          margin: 0;
          text-align: left;
          width: auto;
      }
      label {
          margin: 0;
          position: absolute;
          flex: 1 50%;
          top: 0;
          width: 100%;
          font-weight: 400;
          line-height: 40px;
          padding: 0 32px;
          box-sizing: border-box;
      }
  }
}

.protosite-alert {
  background: #fef7eb;
  border: 1px solid #f6b73c;
  padding: 14px 14px 14px 56px;
  margin-bottom: 2rem;
  position: relative;
  font-size: 1rem;
  &:before {
    content: 'Warning!';
    font-weight: 700;
    display: block;
  }
  &:after {
    content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23f6b73c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true' data-reactid='56'><path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'></path><line x1='12' y1='9' x2='12' y2='13'></line><line x1='12' y1='17' x2='12' y2='17'></line></svg>");
    position: absolute;
    left: 16px;
    top: calc(50% - 12px);
  }
}

.protosite-pattern-illustration {
    position: absolute;
    left: 24px;
    bottom: 48px;
    display: none;
}

input[type='radio'] { transform: scale(1.5); }

.protosite-pattern-embed {
    border: 1px solid #CED4DA;
    box-shadow: 0 1px 4px rgba(14,40,70,.1);
    border-radius: 4px;
    padding: 10px 20px;
    margin: 0 0 1.5em;
    overflow-x: auto;

    .protosite-pattern-code {
        border-radius: 3px;
        margin: -10px -20px;
    }
}

.protosite-pattern-preview {
    padding: 20px 0;

    & + .protosite-pattern-code {
        border-top: 1px solid rgba(0, 0, 0, .2);
        margin: 30px -20px -10px;
    }
}

.protosite-pattern-code {
    background: #f6f7f8;
    padding: 10px 20px;
    margin: -10px -20px;
}

.protosite-specimen {
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, .2);
    box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
    padding: 10px 20px;
    margin: 0 0 1.5em;
    overflow-x: auto;
}

.protosite-specimen-font {
    @include text-display-md;
}

#specimen-zilla-slab {
    @include zilla-slab;
}

#specimen-open-sans {
    @include open-sans;
}

.protosite-section {
    margin: 0 auto 3em;
}

/* PrismJS 1.12.2 */

code[class*="language-"],
pre[class*="language-"] {
	color: black;
	background: none;
	font-size: 1rem;
	text-align: left;
	white-space: pre;
	word-spacing: normal;
	word-break: normal;
	word-wrap: normal;
	line-height: 1.5rem;

	-moz-tab-size: 4;
	-o-tab-size: 4;
	tab-size: 4;

	-webkit-hyphens: none;
	-moz-hyphens: none;
	-ms-hyphens: none;
	hyphens: none;
}

/* Code blocks */
pre[class*="language-"] {
	position: relative;
	margin: .5em 0;
	overflow: visible;
	padding: 0;
}
pre[class*="language-"]>code {
	position: relative;
	background-color: #ffffff;
	background-image: linear-gradient(transparent 50%, #f6f6f6 50%);
	background-size: 3rem 3rem;
	background-origin: content-box;
	background-attachment: local;
}

code[class*="language"] {
	max-height: inherit;
	height: inherit;
	padding: 1.5rem;
	display: block;
	overflow: auto;
}

/* Margin bottom to accomodate shadow */
:not(pre) > code[class*="language-"],
pre[class*="language-"] {
	background-color: #fdfdfd;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	margin-bottom: 1em;
}

/* Inline code */
:not(pre) > code[class*="language-"] {
	position: relative;
	padding: .2em;
	border-radius: 0.3em;
	color: #c92c2c;
	border: 1px solid rgba(0, 0, 0, 0.1);
	display: inline;
	white-space: normal;
}

pre[class*="language-"]:before,
pre[class*="language-"]:after {
	content: '';
	z-index: -2;
	display: block;
	position: absolute;
	bottom: 0.75em;
	left: 0.18em;
	width: 40%;
	height: 20%;
	max-height: 13em;
	box-shadow: 0 13px 8px #979797;
	-webkit-transform: rotate(-2deg);
	-moz-transform: rotate(-2deg);
	-ms-transform: rotate(-2deg);
	-o-transform: rotate(-2deg);
	transform: rotate(-2deg);
}

:not(pre) > code[class*="language-"]:after,
pre[class*="language-"]:after {
	right: 0.75em;
	left: auto;
	-webkit-transform: rotate(2deg);
	-moz-transform: rotate(2deg);
	-ms-transform: rotate(2deg);
	-o-transform: rotate(2deg);
	transform: rotate(2deg);
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #7D8B99;
}

.token.punctuation {
	color: #5F6364;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.function-name,
.token.constant,
.token.symbol,
.token.deleted {
	color: #ff0039;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.function,
.token.builtin,
.token.inserted {
	color: #2eac4c;
}

.token.operator,
.token.entity,
.token.url,
.token.variable {
	color: #a67f59;
	background: rgba(255, 255, 255, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword,
.token.class-name {
	color: #0060DF;
}

.token.regex,
.token.important {
	color: #e90;
}

.language-css .token.string,
.style .token.string {
	color: #a67f59;
	background: rgba(255, 255, 255, 0.5);
}

.token.important {
	font-weight: normal;
}

.token.bold {
	font-weight: bold;
}
.token.italic {
	font-style: italic;
}

.token.entity {
	cursor: help;
}

.namespace {
	opacity: .7;
}

@media screen and (max-width: 767px) {
	pre[class*="language-"]:before,
	pre[class*="language-"]:after {
		bottom: 14px;
		box-shadow: none;
	}

}

/* Plugin styles */
.token.tab:not(:empty):before,
.token.cr:before,
.token.lf:before {
	color: #e0d7d1;
}

/* Plugin styles: Line Numbers */
pre[class*="language-"].line-numbers {
	padding-left: 0;
}

pre[class*="language-"].line-numbers code {
	padding-left: 3.8em;
}

pre[class*="language-"].line-numbers .line-numbers-rows {
	left: 0;
}

/* Plugin styles: Line Highlight */
pre[class*="language-"][data-line] {
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 0;
}
pre[data-line] code {
	position: relative;
	padding-left: 4em;
}
pre .line-highlight {
	margin-top: 0;
}

code.language-markup {
	overflow: hidden;
}

`;

class Editor extends Component {
  constructor() {
    super();
    this.state = {
    }
  }
  render() {
    return (
      <EditorContainer>
        <table className="protosite-pattern-table">
          <tbody>
            <tr>
              <th>Attribute</th>
              <th>Description</th>
              <th>Input</th>
            </tr>
            <tr>
              <td>Type</td>
              <td>What type of button is this?</td>
              <td>
                <select id="button-type" autoComplete="off">
                  <option value="mzp-button-primary" data-display="tr-button-hover">Primary</option>
                  <option value="" data-display="tr-button-hover" selected>Secondary</option>
                  <option value="mzp-button-download" data-display="tr-button-brand">Download</option>
                </select>
              </td>
            </tr>
            <tr id="tr-button-brand" style={{display: 'none'}}>
              <td>Brand</td>
              <td>Is this a branded button?</td>
              <td>
                <select id="button-brand" autoComplete="off">
                  <option value="" data-require="Download" selected>Default</option>
                  <option value="mzp-button-firefox" data-require="Download Firefox">Firefox</option>
                  <option value="mzp-button-beta" data-require="Download Beta">Beta</option>
                  <option value="mzp-button-nightly" data-require="Download Nightly">Nightly</option>
                  <option value="mzp-button-devedition" data-require="Download Dev Edition">Dev Edition</option>
                  <option value="mzp-button-focus" data-require="Download Focus">Focus</option>
                </select>
              </td>
            </tr>
            <tr id="tr-button-hover">
              <td>Brand</td>
              <td>Is this a branded button?</td>
              <td>
                <select id="button-hover" autoComplete="off">
                  <option value="" selected>Default</option>
                  <option value="mzp-button-shift">Mozilla</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Size</td>
              <td>What size is the button?</td>
              <td>
                <select id="button-size" autoComplete="off">
                  <option value="mzp-button-small">Small</option>
                  <option value="" selected>Medium</option>
                  <option value="mzp-button-large">Large</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Text</td>
              <td>What should the button say?</td>
              <td>
                <input id="button-text" type="text" data-maxlength="20" defaultValue="Button" autoComplete="off" />
              </td>
            </tr>
            <tr>
              <td>Id</td>
              <td>A unique identifier for the button</td>
              <td>
                <input id="button-id" type="text" value="" autoComplete="off" />
              </td>
            </tr>
            <tr>
              <td>Link</td>
              <td>Is this button a link to a new page?</td>
              <td>
                <div id="button-link" className="protosite-toggle">
                  <div className="protosite-toggle-option">
                    <input id="button-link-on" type="radio" name="button-link" value="on" autoComplete="off" data-display="tr-button-url" />
                    <label htmlFor="button-link-on">True</label>
                  </div>
                  <div className="protosite-toggle-option">
                    <input id="button-link-off" type="radio" name="button-link" value="off" defaultChecked autoComplete="off" />
                    <label htmlFor="button-link-off">False</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr id="tr-button-url" style={{display: 'none'}}>
              <td>Link URL</td>
              <td>Clicking the card will send you to this destination</td>
              <td>
                <input id="button-url" type="text" defaultValue="#" autoComplete="off" />
              </td>
            </tr>
          </tbody>
        </table>

        <div id="alert"></div>

        <div className="protosite-pattern-embed">
          <div className="protosite-pattern-preview ">  
            <button className="mzp-button">
              Button
            </button>
          </div>
          <pre className="protosite-pattern-code language-markup"><code id="language-markup" className=" language-markup"><span className="token tag"><span className="token tag"><span className="token punctuation">&lt;</span>button</span> <span className="token attr-name">class</span><span className="token attr-value"><span className="token punctuation">=</span><span className="token punctuation">"</span>mzp-button<span className="token punctuation">"</span></span><span className="token punctuation">&gt;</span></span>Button<span className="token tag"><span className="token tag"><span className="token punctuation">&lt;/</span>button</span><span className="token punctuation">&gt;</span></span></code></pre>
        </div>
      </EditorContainer>
    );
  }
  componentDidMount() {
    var requireString = null;
    var testit = null;
    var selectedString = null;
    var selectedTest = null;

    // Dropdown Listener
    function addEventHandler(elem, eventType, handler) {
        if (elem.addEventListener)
            elem.addEventListener (eventType, handler, false);
        else if (elem.attachEvent)
            elem.attachEvent ('on' + eventType, handler);
    }

    // Replace Text
    function replaceText(inputID, componentID) { // eslint-disable-line no-unused-vars

        var inputInitialValue = document.getElementById(inputID).value;
        var storedInitialValue = inputInitialValue;

        document.getElementById(inputID).onkeyup = function() {
            // Component
            var getInput = document.getElementById(inputID);
            var getComponent = document.getElementsByClassName(componentID)[0];
            var optionHasMaxLength = getInput.hasAttribute('data-maxlength');

            getComponent.textContent = document.getElementById(inputID).value;

            // Max length
            if (optionHasMaxLength) {
                var characterMax = getInput.dataset.maxlength;
                var characterLength = getInput.value.length;
                var characterDifference = Math.abs(getInput.dataset.maxlength - getInput.value.length);
                var characterMessage = 'This component has ' +  characterLength + ' characters, ' + characterDifference + ' more than the maximum limit of ' + characterMax + ' characters.';
                var getMessageId = document.getElementById('message-maxlength_' + inputID);

                if (characterLength > characterMax) {
                    if (document.getElementById('alert').contains(document.getElementById('message-maxlength_' + inputID))) {
                        getMessageId.id = 'message-maxlength_' + inputID;
                        getMessageId.innerHTML = characterMessage;
                    } else {
                        document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message-maxlength_' + inputID + '" class="protosite-alert">' + characterMessage + '</div>');
                    }
                } else {
                    if (document.getElementById('alert').contains(getMessageId)) {
                        document.getElementById('alert').removeChild(getMessageId);
                    }
                }
            }
            
            // Min Length

            // Required String
            if (requireString !== null) {
                var requireId = document.getElementById('message-require_' + testit);
                var requireMessage = 'This component doesnt include the phrase: ' + requireString;

                if (document.getElementById(inputID).value.includes(requireString)) {
                    if (document.getElementById('alert').contains(requireId)) {
                        document.getElementById('alert').removeChild(requireId);
                    }
                } else {
                    if (document.getElementById('alert').contains(requireId)) {
                        requireId.innerHTML = requireMessage;
                    } else {
                        document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message-require_' + testit + '" class="protosite-alert">' + requireMessage + '</div>');
                    }
                }
            }
            
            // Prohibited String

            // Selected String
            if (selectedString !== null) {
                var selectedStringId = document.getElementById('message-require_' + selectedTest);
                var selectedMessage = 'This component doesnt include the phrase: ' + selectedString;

                if (document.getElementById(inputID).value.includes(selectedString)) {
                    if (document.getElementById('alert').contains(selectedStringId)) {
                        document.getElementById('alert').removeChild(selectedStringId);
                    }
                } else {
                    if (document.getElementById('alert').contains(selectedStringId)) {
                        selectedStringId.innerHTML = selectedMessage;
                    } else {
                        document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message-require_' + selectedTest + '" class="protosite-alert">' + selectedMessage + '</div>');
                    }
                }
            }

            // Wrap value in 'changethis_' + inputID
            var getCodeSample = document.getElementById('language-markup').innerHTML; //remove?
            if (!getCodeSample.includes('changethis_' + inputID)) {
                var wrapCodeSample = getCodeSample.replace(inputInitialValue, '<span id="changethis_' + inputID + '">' + inputInitialValue + '</span>');
                document.getElementById('language-markup').innerHTML = wrapCodeSample;
            }

            // Code Sample
            //var getCodeSampleText;
            //if (document.getElementById('changethis_' + inputID)) {
            var getCodeSampleText = document.getElementById('changethis_' + inputID).innerHTML;
            //}
            var inputValue = document.getElementById(inputID).value;
            var newCodeSample = getCodeSampleText.replace(inputInitialValue, inputValue);

            if (inputValue.length > 0) {
                document.getElementById('changethis_' + inputID).innerHTML = newCodeSample;
                var promise1 = new Promise(function(resolve) {
                    resolve('Success!');
                });

                promise1.then(function() {
                    inputInitialValue = inputValue;
                });
            } else if (inputValue.length == 0) {
                document.getElementById('changethis_' + inputID).innerHTML = getCodeSampleText.replace(inputInitialValue, storedInitialValue);
                var promise2 = new Promise(function(resolve) {
                    resolve('Success!');
                });

                promise2.then(function() {
                    inputInitialValue = storedInitialValue;
                });
            }

        };
    }

    // Add Class
    function addClass(inputID, componentID) { // eslint-disable-line no-unused-vars

        addEventHandler(document, 'DOMContentLoaded', function() {

            // Identify Text Input
            var textInput = inputID.split('-')[0];
            textInput += '-text';
            if (document.getElementById(textInput)) {
                var textInputValue = document.getElementById(textInput).value;
            }

            addEventHandler(document.getElementById(inputID), 'change', function() {
                var getComponent = document.getElementsByClassName(componentID)[0];
                var inputValue = this.value;

                // Identify other values
                function getChildren(parent, selector) {
                    return Array.prototype.filter.call(parent.children, function(node) {
                        return node.matches(selector);
                    });
                }
                var children = getChildren(this, 'option');

                // Remove other values
                for (var int = 0; int < children.length; int++) {
                    if( children[int].value && children[int].value !== inputValue) {
                        getComponent.classList.remove(children[int].value);
                        document.getElementById('language-markup').innerHTML = document.getElementById('language-markup').innerHTML.replace(children[int].value, '');
                    }
                }

                // Add class to component
                if(inputValue) {
                    if (getComponent.classList) {
                        getComponent.classList.add(inputValue);
                    } else {
                        getComponent.inputValue += '' + inputValue;
                    }
                }

                // Add class to code sample
                var promise3 = new Promise(function(resolve) { // replace promise3 // var promise3 = new Promise(function(resolve, reject) {
                    resolve('Success!');

                    var getCodeSample = document.getElementById('language-markup').innerHTML; //remove?
                    if (!getCodeSample.includes('changethis_' + inputID)) {
                        var wrapCodeSample = document.getElementById('language-markup').innerHTML.replace(textInputValue, '<span id="changethis_' + inputID + '">' + textInputValue + '</span>');
                        document.getElementById('language-markup').innerHTML = wrapCodeSample;
                    }

                });
                promise3.then(function() {
                    var updateCodeSample = document.getElementById('language-markup').innerHTML.replace(componentID, componentID + ' ' + inputValue);
                    document.getElementById('language-markup').innerHTML = updateCodeSample;
                    document.getElementsByClassName('token attr-value')[0].innerHTML = document.getElementsByClassName('token attr-value')[0].innerHTML.replace(/\s+/g,' ').trim();

                });

                // Data Attributes
                for (var i = 0; i < children.length; i++) {

                    var optionValue = children[i].value;

                    var messageOption = children[i].dataset.message;
                    var messageOptionHas = children[i].hasAttribute('data-message');
                    var messageId = document.getElementById('message_' + inputID);

                    var requireOption = children[i].dataset.require;
                    var requireOptionHas = children[i].hasAttribute('data-require');
                    var requireId = document.getElementById('message-require_' + inputID);
                    var requireMessage = 'This component doesnt include the phrase: ' + requireOption;

                    var displayOption = children[i].dataset.display;
                    var displayOptionHas = children[i].hasAttribute('data-display');

                    if (optionValue == this.value) {

                        // data-message
                        if (messageOptionHas) {
                            if (document.getElementById('alert').contains(messageId)) {
                                messageId.innerHTML = messageOption;
                            } else {
                                document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message_' + inputID + '" class="protosite-alert">' + messageOption + '</div>');
                            }
                        } else {
                            if (document.getElementById('alert').contains(messageId)) {
                                document.getElementById('alert').removeChild(messageId);
                            }
                        }

                        // data-require
                        if (document.getElementById(textInput).value.includes(requireOption)) {
                            requireString = requireOption;
                            testit = inputID;
                        } else {
                            if (requireOptionHas) {
                                if (document.getElementById('alert').contains(requireId)) {
                                    requireId.innerHTML = requireMessage;
                                } else {
                                    document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message-require_' + inputID + '" class="protosite-alert">' + requireMessage + '</div>');
                                }
                                requireString = requireOption;
                                testit = inputID;
                            } else {
                                if (document.getElementById('alert').contains(requireId)) {
                                    document.getElementById('alert').removeChild(requireId);
                                }
                                requireString = null;
                                testit = null;
                            }
                        }

                        // data-display
                        if (displayOptionHas) {
                            document.getElementById(displayOption).style.display = 'table-row';
                            var displayOptionSource;
                            var displayInputId;
                            displayOptionSource = displayOption;
                            displayInputId = inputID;

                            var selectedOptionID = document.getElementById(displayOption).getElementsByTagName('select')[0].id;
                            var selectedOption = document.getElementById(displayOption).getElementsByTagName('option')[0].dataset.require;
                            var selectedOptionHas = document.getElementById(displayOption).getElementsByTagName('option')[0].hasAttribute('data-require');
                            var selectedId = document.getElementById('message-require_' + selectedOptionID);
                            var selectedMessage = 'This component doesnt include the phrase: ' + selectedOption;


                            if (document.getElementById(textInput).value.includes(selectedOption)) {
                                selectedString = selectedOption;
                                selectedTest = selectedOptionID;
                            } else {
                                if (selectedOptionHas) {
                                    if (document.getElementById('alert').contains(selectedId)) {
                                        selectedId.innerHTML = selectedMessage;
                                    } else {
                                        document.getElementById('alert').insertAdjacentHTML('beforeend', '<div id="message-require_' + selectedOptionID + '" class="protosite-alert">' + selectedMessage + '</div>');
                                    }
                                    selectedString = selectedOption;
                                    selectedTest = selectedOptionID;
                                } else {
                                    var alertMessage = document.getElementById('alert');
                                    if (alertMessage.hasChildNodes()) {
                                      alertMessage.removeChild(alertMessage.childNodes[0]);
                                    }
                                    selectedString = null;
                                    selectedTest = null;
                                }
                            }

                            var p = 0;
                            while (p < children.length) {
                                p++;

                                if ((p - 1) != i) {
                                    var displayOptionSiblings = children[(p - 1)].dataset.display;

                                    if (displayOptionSiblings != displayOption) {
                                        document.getElementById(displayOptionSiblings).style.display = 'none';

                                        // Remove other values
                                        var displayOptionSiblingsId = document.getElementById(displayOptionSiblings);
                                        var selectId = displayOptionSiblingsId.getElementsByTagName('select')[0];
                                        var selectOptions = displayOptionSiblingsId.getElementsByTagName('select')[0].children;

                                        for (var q = 0; q < selectOptions.length; q++) {
                                            var selectOptionValue = selectId.getElementsByTagName('option')[q].value;

                                            if (getComponent.classList.contains(selectOptionValue)) {

                                                // Code Sample
                                                document.getElementById('language-markup').innerHTML = document.getElementById('language-markup').innerHTML.replace(selectOptionValue, '');

                                                // Component
                                                setTimeout(getComponent.classList.remove(selectOptionValue), 3000);

                                                // Input
                                                selectId.selectedIndex = 0;

                                                // Alert
                                                if (document.getElementById('alert').contains(document.getElementById('message-require_' + selectId.id))) {
                                                    document.getElementById('alert').removeChild(document.getElementById('message-require_' + selectId.id));
                                                }

                                            }

                                        }

                                    }
                                }
                            }
                        } else {
                            if (inputID == displayInputId) {
                                document.getElementById(displayOptionSource).style.display = 'none';
                            }
                        }

                    }

                }

            });
        });
    }

    // Set Attribute
    function addAttribute(inputID, componentID, attribute) { // eslint-disable-line no-unused-vars
        var initialInput = document.getElementById(inputID).value;
        document.getElementById(inputID).onkeyup = function() {
            var getInput = document.getElementById(inputID).value;
            var getComponent = document.getElementsByClassName(componentID)[0];
            var getCodeSample = document.getElementById('language-markup').innerHTML;
            var attributeMarkup = '<span class="token attr-name">' + attribute + '</span>';
            var updateCodeSample;

            if (getInput != null && getInput.length > 0) {
                if (getCodeSample.includes(inputID + '_replace-attribute')) {
                    document.getElementById(inputID + '_replace-text').innerHTML = getInput;
                } else if (getCodeSample.includes(attributeMarkup)) {
                    updateCodeSample = getCodeSample.replace('<span class="token attr-name">' + attribute + '</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>' + initialInput + '<span class="token punctuation">"</span></span>', '<span id="' + inputID + '_replace-attribute"><span class="token attr-name">' + attribute + '</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span><span id="' + inputID + '_replace-text" class="token attr-value">' + getInput + '</span><span class="token punctuation">"</span></span></span>');
                    document.getElementById('language-markup').innerHTML = updateCodeSample;
                } else {
                    var testString = '<span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>' +  componentID;
                    updateCodeSample = getCodeSample.replace(testString, '<span id="' + inputID + '_replace-attribute"><span class="token attr-name">' + attribute + '</span><span class="token punctuation">="</span><span id="' + inputID + '_replace-text" class="token attr-value">' + getInput + '</span><span class="token punctuation">" </span></span>' + testString );
                    document.getElementById('language-markup').innerHTML = updateCodeSample;
                }
                getComponent.setAttribute(attribute, getInput);
            } else {
                if(document.getElementById(inputID + '_replace-attribute')) {
                    document.getElementById(inputID + '_replace-attribute').outerHTML = '';
                } else if (getCodeSample.includes(attributeMarkup)) {
                    updateCodeSample = getCodeSample.replace('<span class="token attr-name">' + attribute + '</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>' + initialInput + '<span class="token punctuation">"</span></span>', '');
                    document.getElementById('language-markup').innerHTML = updateCodeSample;
                }
                getComponent.removeAttribute(attribute);
            }
        };
    }

    // Toggle Attribute
    // toggleAttribute(inputID, componentID, attribute)
    // toggleAttribute('card-meta', 'mzp-card-content', '<p class="mzp-card-meta">6 hours ago</p>')

    // Button Toggle
    function attributeReplace(inputID, componentID, tagInitial, tagReplace) { // eslint-disable-line no-unused-vars
        var buttonLinkOn = document.getElementById('button-link-on');
        var buttonLinkOff = document.getElementById('button-link-off');
        var tagOpenCurrent = '<span class="token tag"><span class="token punctuation">&lt;</span>' + tagInitial + '</span>';
        var tagOpenNew = '<span class="token tag"><span class="token punctuation">&lt;</span>' + tagReplace + '</span><span id="button-url_replace-attribute"><span class="token attr-name"> href</span><span class="token punctuation">="</span><span id="button-url_replace-text" class="token attr-value">#</span><span class="token punctuation">"</span></span>';
        var tagCloseCurrent = '<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>' + tagInitial + '</span><span class="token punctuation">&gt;</span></span>';
        var tagCloseNew = '<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>' + tagReplace + '</span><span class="token punctuation">&gt;</span></span>';

        buttonLinkOn.addEventListener('change', function () {
            if (buttonLinkOn.checked) {
                if (buttonLinkOn.hasAttribute('data-display')) { //data-display
                    var getCodeSample = document.getElementById('language-markup').innerHTML;
                    document.getElementById(buttonLinkOn.dataset.display).style.display = 'table-row';
                    document.getElementById('language-markup').innerHTML = getCodeSample.replace(tagOpenCurrent, tagOpenNew).replace(tagCloseCurrent, tagCloseNew);
                }
            }
        });

        buttonLinkOff.addEventListener('change', function () {
            if (buttonLinkOff.checked) {

                var getCodeSample = document.getElementById('language-markup').innerHTML;
                document.getElementById(buttonLinkOn.dataset.display).style.display = 'none';
                document.getElementById('language-markup').innerHTML = getCodeSample.replace('<span class="token tag"><span class="token punctuation">&lt;</span>a</span>', tagOpenCurrent).replace(tagCloseNew, tagCloseCurrent);
                document.getElementById('button-url_replace-attribute').outerHTML = '';
            }
        });
    }
    
    // Actions
    addClass('button-type', 'mzp-button');
    addClass('button-brand', 'mzp-button');
    addClass('button-hover', 'mzp-button');
    addClass('button-size', 'mzp-button');
    replaceText('button-text', 'mzp-button');
    addAttribute('button-id', 'mzp-button', 'id');
    attributeReplace('button-link', 'mzp-button', 'button', 'a')
    addAttribute('button-url', 'mzp-button', 'href');
  }
  

}

export default Editor;



// WEBPACK FOOTER //
// src/assets/Mozilla/ComponentEditor/Editor/Editor.js